import { RowTypes } from '../../enums/pdf-tron/row-types.enum';

export interface INotesTableData {
    rowType: RowTypes;
    t: string | null;
    pV1?: string | null;
    pV2?: string | null;
    cV1?: string | null;
    cV2?: string | null;
    tR?: string | null;
}
